// extracted by mini-css-extract-plugin
export default {"reason":"reason---iBD7z"};